import { render } from "./VersionsView.vue?vue&type=template&id=1e84c9c2"
import script from "./VersionsView.vue?vue&type=script&lang=js"
export * from "./VersionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__